<template>
	<div class="quiz-result-card">
		<div class="quiz-result-card__title">{{ props.result.title }}</div>
		<div class="quiz-result-card__text">{{ props.result.text }}</div>

		<a :href="props.result.product.link" target="_blank" class="quiz-result-card__product" @click="productClick()">
			<div class="quiz-result-card__badge">{{ props.result.rating }}</div>

			<div class="quiz-result-card__product-image">
				<img
					v-if="props.result.product.image"
					:src="props.result.product.image"
					:alt="props.result.product.name"
				/>
			</div>

			<div class="quiz-result-card__product-name">
				{{ props.result.product.name }}
			</div>

			<div class="quiz-result-card__specs">
				{{ props.result.product.props.join(' • ') }}
			</div>

			<div v-if="props.result.product?.reviews?.count" class="quiz-result-card__reviews">
				<span class="quiz-result-card__reviews-rating">★ {{ props.result.product.reviews.rating }}</span>
				<span>•</span>
				<span>{{ props.result.product.reviews.count }} отзывов</span>
			</div>

			<div v-if="props.result.product?.price?.current" class="quiz-result-card__price">
				<span class="quiz-result-card__price-current">{{ props.result.product.price.current }} ₽</span>
				<span
					v-if="props.result.product.price.old"
					class="quiz-result-card__price-old"
				>{{ props.result.product.price.old }} ₽</span>
			</div>
		</a>
	</div>
</template>

<script setup lang="ts">
interface Props {
	id: string;
	placement: string;
	result: QuizResult;
}

const props = defineProps<Props>();

const productClick = ()=> {
	(window.dataLayer = window.dataLayer || []).push({
		event: 'quiz_event',
		quiz_event_name: 'quiz_product_click',
		quiz_category: props.id,
		quiz_placement: props.placement,
		quiz_product_id: props.result.product.id,
		quiz_product_name: props.result.product.name
	});
};
</script>